var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "eye-check_svg__icon eye-check_svg__icon-tabler eye-check_svg__icon-tabler-eye-check",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 19c-4 0-7.333-2.333-10-7 2.667-4.667 6-7 10-7s7.333 2.333 10 7c-.42.736-.858 1.414-1.311 2.033M15 19l2 2 4-4"
})));
export default SvgEyeCheck;